import { faqs } from "@/mocks/comics";

export default function FAQSection() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <div className="max-w-3xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
            常见问题
          </h2>
          <p className="text-sm text-foreground-600 mt-3">关于韩漫屋，您可能想了解的事情</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <details key={index} className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <span className="text-sm font-medium text-foreground-950 pr-4">{faq.question}</span>
                <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-700 leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}